import { render, staticRenderFns } from "./PositionEvaluationSummaryTable.vue?vue&type=template&id=2020a8f8&scoped=true&"
import script from "./PositionEvaluationSummaryTable.vue?vue&type=script&lang=js&"
export * from "./PositionEvaluationSummaryTable.vue?vue&type=script&lang=js&"
import style0 from "./PositionEvaluationSummaryTable.vue?vue&type=style&index=0&id=2020a8f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2020a8f8",
  null
  
)

export default component.exports